import { render, staticRenderFns } from "./XinguanOrderModal__Style#Drawer.vue?vue&type=template&id=1f724be5&scoped=true&"
import script from "./XinguanOrderModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./XinguanOrderModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./XinguanOrderModal__Style#Drawer.vue?vue&type=style&index=0&id=1f724be5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f724be5",
  null
  
)

export default component.exports